import React, { useRef, useContext, useState, useCallback, useEffect } from 'react';
import { useAutocomplete } from '@mui/material';
import styled from '@mui/styled-engine';
import { CloseOutlined } from '@mui/icons-material';

import {
	Modal,
	FormGroup,
	Input,
	Label,
	Row,
	Col,
	InputGroup,
	InputGroupText,
} from 'reactstrap';
import { LoaderMini } from '~/components/Loaders';
import { ExtratoContext } from '~/context/ExtratoContext';
import { color } from '~/assets/styles/colors';
import { ModalGeral } from '~/components/ModalGeral';
import CurrencyInput from 'react-currency-input';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { PedidoContext } from '~/context/PedidoContext';
import { convertPriceToNumber } from '~/helpers/price';
import ReactGA from 'react-ga4';
import getValidationErrors from '../../../utils/getValidationErrors';

import {
	ModalFooterCss,
	Title,
	InputCss,
	ButtonCss,
	ModalBodyCss,
	TextError,
} from './styles';






export function ModalSolicitarPedido(props) {
	const {
		loadingSaldoDisponivel,
		setLoadingSaldoDisponivel,
		montanteDestinatario,
		getSaldoDisponivel
	} = useContext(ExtratoContext);

	const { solicitarPedido, getPedidos } = useContext(PedidoContext);

	const { toggle, setToggle, setMeusLancamentos, destinatarios, setAtualizaNF } = props;
	const formRef = useRef(null);
	const [isMobile, setIsMobile] = useState(false);
	const [documentoDestinatario, setDocumentoDestinatario] = useState("");

	// const [inputChange, setInputChange] = useState('')

	const [post, setPost] = useState({
		id_destinatario: '',
		numero_pedido: '',
		nota_fiscal: '',
		valor_pedido: '',
		descricao: '',
	});

	const [emptyError, setEmptyError] = useState({
		id_destinatario: '',
		numero_pedido: '',
		nota_fiscal: '',
		valor_pedido: '',
		descricao: ''
	});

	const LancarPedido = useCallback(async () => {
		try {
			const schema = Yup.object().shape({
				id_destinatario: Yup.string()
					.notOneOf(['0'], 'ID não pode ser 0')
					.required('Insira o ID'),

				numero_pedido: Yup.string()
					.notOneOf(['0'], 'o número de referência não pode ser 0')
					.required('Insira o número de pedido'),

				nota_fiscal: Yup.string(),

				valor_pedido: Yup.string()
					.notOneOf(['0', '0,00'], 'Valor não pode ser 0')
					.required('Insira o valor do pedido'),
				descricao: Yup.string()
			});

			await schema.validate(post, {
				abortEarly: false,
			});
			// setEmptyError(schema._nodes);
			solicitarPedido(post).then((res) => {
				if (res === 'Request failed with status code 409') {
					const currentEmptyError = { ...emptyError };
					currentEmptyError.numero_pedido = 'Nº Referência de pedido já existe. Tente um outro número.';
					setEmptyError(currentEmptyError);
				} else {
					setToggle(false);
					getPedidos(10, 1, 'enviados').then((resp) => setMeusLancamentos(resp.data.pedidos))
					setAtualizaNF('mudou')
					setPost({
						id_destinatario: '',
						numero_pedido: '',
						nota_fiscal: '',
						valor_pedido: '',
						descricao: '',
					})
				}
			});
			handleClickNovoLancamentoGA4();
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errors = getValidationErrors(err);
				setEmptyError(errors);
			}
		}
	})

	const Listbox = styled('ul')({
		width: '100%',
		margin: 0,
		padding: 0,
		zIndex: 1,
		position: 'absolute',
		listStyle: 'none',
		backgroundColor: '#fff',
		overflow: 'auto',
		maxHeight: 200,
		border: '1px solid rgba(0,0,0,.25)',
		'& li.Mui-focused': {
			backgroundColor: '#4a8df6',
			color: 'white',
			cursor: 'pointer',
		},
		'& li:active': {
			backgroundColor: '#2977f5',
			color: 'white',
		},
	});

	const {
		getRootProps,
		getInputProps,
		getListboxProps,
		getOptionProps,
		groupedOptions,
	} = useAutocomplete({
		options: destinatarios || [],
		getOptionLabel: (option) => `#${option?.documento} | ${option.nome} | ${option.id}`,
		onChange: (option) =>{
			changeMontanteDestinario(option.target.value.toString());
			setPost({
				...post,
				id_destinatario: option.target.value.toString(),
			})

		}
	});

	function handleClickNovoLancamentoGA4() {
		ReactGA.event({
			category: "novo_lancamento_click",
			action: "Novo Lançamento",
			label: "Efetuando Novo Lançamento",
		});
	}

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
		const currentEmptyError = { ...emptyError };
		currentEmptyError.id_destinatario = '';
		setEmptyError(currentEmptyError);
	}, [post]);

	function changeMontanteDestinario(id) {
		const index = destinatarios.findIndex((item) => item.id === id);

		if(index >= 0){
			setDocumentoDestinatario(destinatarios[index]?.documento);
		}
	};

	const [showModalSaldo, setShowModalSaldo] = useState(false);
	function saldoValido(montante, valorPedido) {
		if(montante && valorPedido ){
			if((montante - valorPedido) >= 0){
				return true;
			}
			return false;
		}
		return false;
	}

	useEffect(() => {
		async function fetchData() {
			if(documentoDestinatario){
				setLoadingSaldoDisponivel(true);
				await getSaldoDisponivel(documentoDestinatario)
			}
		}

		fetchData();

	}, [documentoDestinatario]);

	return (
		<Modal isOpen={toggle} size="lg">
			<Form ref={formRef}>
				<Title className="d-flex align-items-center justify-content-between">
					Nova Ordem de Pagamento
					<ButtonCss
						style={{
							borderRadius: 0,
							padding: 0,
							marginRight: '25px',
							backgroundColor: '#D3FBE1',
							border: `1px solid #D3FBE1`,
						}}
						className="d-flex align-items-center justify-content-center"
						onClick={() => {
							setPost({
								id_destinatario: '',
								numero_pedido: '',
								nota_fiscal: '',
								valor_pedido: '',
								descricao: '',
							});
							setToggle(false)
						}}>
						<CloseOutlined />
					</ButtonCss>
				</Title>
				<ModalBodyCss>
					<Row xs="12" md="12" lg="12">
						<Col xs="12" md="12" lg="12">
							<FormGroup>
								<Label className="notranslate">Documento</Label>
								<div {...getRootProps()}>
									<input placeholder='Digite o Nome ou Documento' className='form-control' {...getInputProps()} />
								</div>
								{groupedOptions.length > 0 ? (
									<Listbox {...getListboxProps()}>
										{groupedOptions.map((option, index) => (
											<li style={{ padding: '5px' }} {...getOptionProps({ option, index })} value={option.id}>
												{`#${option?.documento ? option?.documento : option.id} | ${option.nome}`}
											</li>
										))}
									</Listbox>
								) : null}
								{emptyError.id_destinatario !== '' ? (
									<TextError>
										{emptyError.id_destinatario}
									</TextError>
								) : (
									<></>
								)}
							</FormGroup>
						</Col>
						<Col xs="6" md="12" lg="6">
							<FormGroup>
								{isMobile ? <Label>Referência</Label> : <Label>Referência do Pedido</Label>}

								<Input
									name="numero_pedido"
									type="text"
									min={0}
									value={post.numero_pedido}
									onChange={(elemento) => {
										const currentEmptyError = { ...emptyError };
										currentEmptyError.numero_pedido = '';
										setEmptyError(currentEmptyError);
										setPost({
											...post,
											numero_pedido:
												elemento.target.value.replace(/[^\w\s]/gi, ""),
										})
									}
									}
								/>

								{emptyError.numero_pedido !== '' ? (
									<TextError>
										{emptyError.numero_pedido}
									</TextError>
								) : (
									<></>
								)}
							</FormGroup>
						</Col>

						<Col xs="6" md="12" lg="6">
							<FormGroup>
								<Label>Valor do Pedido</Label>

								<InputGroup>
									<InputGroupText style={{ borderRadius: 0 }}>
										R$
									</InputGroupText>

									<CurrencyInput
										type="text"
										className="form-control"
										placeholder="00,00"
										decimalSeparator=","
										thousandSeparator="."
										value={post.valor_pedido}
										onChangeEvent={(input) => {
											const currentEmptyError = { ...emptyError };
											currentEmptyError.valor_pedido = '';
											setEmptyError(currentEmptyError);
											setPost({
												...post,
												valor_pedido: convertPriceToNumber(input.target
													.value)
											});
										}}
									/>
								</InputGroup>

								{emptyError.valor_pedido !== '' ? (
									<TextError>
										{emptyError.valor_pedido}
									</TextError>
								) : (
									<></>
								)}
							</FormGroup>
						</Col>

						<Col xs="6" md="12" lg="6">
							<FormGroup>
								<Label>Nota Fiscal</Label>

								<Input
									name="nota_fiscal"
									type="text"
									min={0}
									value={post.nota_fiscal}
									onChange={(elemento) =>
										setPost({
											...post,
											nota_fiscal: elemento.target.value,
										})
									}
									placeholder="000000"
								/>

								{emptyError.nota_fiscal !== '' ? (
									<TextError>
										{emptyError.nota_fiscal}
									</TextError>
								) : (
									<></>
								)}
							</FormGroup>
						</Col>

						<Col xs="12" md="12" lg="12">
							<FormGroup>
								<Label>Descrição</Label>

								<InputCss
									name="descricao"
									type="textarea"
									value={post.descricao}
									onChange={(elemento) =>
										setPost({
											...post,
											descricao: elemento.target.value,
										})
									}
								/>
							</FormGroup>
						</Col>
					</Row>
				</ModalBodyCss>

				<ModalFooterCss>
					<ButtonCss
						size="sm"
						style={{
							padding: `${isMobile && '14px 48px 14px 48px'}`,
						}}
						onClick={() => {
							setPost({
								id_destinatario: '',
								numero_pedido: '',
								nota_fiscal: '',
								valor_pedido: '',
								descricao: '',
							});
							setToggle(false)
						}}>
						CANCELAR
					</ButtonCss>

					<ButtonCss
						size="sm"
						style={{
							padding: `${isMobile && '14px 48px 14px 48px'}`,
						}}
						onClick={() => setShowModalSaldo(true)}>
						ENVIAR PEDIDO
					</ButtonCss>
				</ModalFooterCss>
			</Form>



		<>
			{saldoValido(montanteDestinatario, post.valor_pedido)
				? (
					<ModalGeral
						text="O saldo do cliente é suficiente para concluir este pedido. Deseja prosseguir?"
						handleRightButton={LancarPedido}
						toggle={showModalSaldo}
						setToggle={setShowModalSaldo}
					>
					{loadingSaldoDisponivel
						?
							<LoaderMini />
						:
						<Col xs="12" md="12" lg="12">

							<FormGroup>
								<Label style={{display: `flex`, justifyContent: "space-between"}}>
									Saldo Disponível:
									<b style={{color: `${color.green}`}}>
										{montanteDestinatario ? montanteDestinatario.toLocaleString('pt-BR',	{style: 'currency',currency: 'BRL'}) : 0 }
									</b>
								</Label>
							</FormGroup>

							<FormGroup>
								<Label style={{display: `flex`, justifyContent: "space-between"}}>
									Valor do Pedido:
									<b>
										{post.valor_pedido ? ( post.valor_pedido).toLocaleString('pt-BR',	{style: 'currency',currency: 'BRL'}) : 0 }
									</b>
								</Label>
							</FormGroup>

							<FormGroup>
								<Label style={{display: `flex`, justifyContent: "space-between"}}>
									Saldo Restante:
									<b style={{color: `${color.green}`}}>
										{montanteDestinatario && post?.valor_pedido ? (montanteDestinatario-post.valor_pedido).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})  : "Quebra de valores" }
									</b>
								</Label>
							</FormGroup>
						</Col>
					}

					</ModalGeral>
				)
				: (
					<ModalGeral
						text="O saldo do cliente é insuficiente para finalizar este pedido."
						title="Saldo insuficiente!"
						showRightButton={false}
						buttonLeftText='FECHAR'
						toggle={showModalSaldo}
						setToggle={setShowModalSaldo}
					>
						{loadingSaldoDisponivel
							?
								<LoaderMini />
							:
							<Col xs="12" md="12" lg="12">
								<FormGroup>
									<Label style={{display: `flex`, justifyContent: "space-between"}}>
										Saldo Disponível:
										<b style={{color: `${color.green}`}}>
											{montanteDestinatario ? montanteDestinatario.toLocaleString('pt-BR',	{style: 'currency',currency: 'BRL'}) : 0 }
										</b>
									</Label>
								</FormGroup>
								<FormGroup>
									<Label style={{display: `flex`, justifyContent: "space-between"}}>
										Valor do Pedido:
										<b>
											{post.valor_pedido ? ( post.valor_pedido).toLocaleString('pt-BR',	{style: 'currency',currency: 'BRL'}) : 0 }
										</b>
									</Label>
								</FormGroup>
								<FormGroup>
									<Label style={{display: `flex`, justifyContent: "space-between"}}>
										Diferença de saldo:
										<b style={{color: `${color.red}`}}>
											{montanteDestinatario && post?.valor_pedido ? (montanteDestinatario-post.valor_pedido).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})  : "Nenhum valor selecionado" }
										</b>
									</Label>
								</FormGroup>
							</Col>
						}

					</ModalGeral>
				)
			}
		</>


		</Modal>
	);
}
